import { useToast } from '@/composables/useToast';
import { useViewerItemStore, ItemSharingMode } from '@/modules/viewer/store/useViewerItemStore';

export const useSecurity = () => {
  const viewerItemStore = useViewerItemStore();
  const { error } = useToast();

  const changeSharingMode = (sharing: ItemSharingMode) => {
    viewerItemStore.saveSecurity({ sharing }).catch(() => {
      error('Cannot update item');
    });
  };

  const changePassword = (password: string) => {
    viewerItemStore.saveSecurity({ sharing: ItemSharingMode.PASSWORD, password }).catch(() => {
      error('Cannot update password');
    });
  };

  const addSharingEmails = (newEmails: string[]): Promise<boolean> => {
    return changeSharingEmails([...(viewerItemStore.sharingSpecificUsers || []), ...newEmails]);
  };

  const changeSharingEmails = (emailShares: string[]): Promise<boolean> => {
    return viewerItemStore
      .saveSecurity({ emailShares, emailSharesChanged: true })
      .then(() => true)
      .catch((e: any) => {
        const errorMessage = e?.errors?.[0]?.detail || "Couldn't update email invitations. Please try again.";
        error(errorMessage);
        return false;
      });
  };

  return { addSharingEmails, changePassword, changeSharingMode, changeSharingEmails };
};
